import React, { Component, Fragment } from 'react';
import { Row } from 'reactstrap';
import PropTypes from 'prop-types';
import styles from './CheckoutEventPreview.scss';
import { getPreviewUrl } from 'lib/support';
import moment from 'moment';

export default class CheckoutEventPreview extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    isPolling: PropTypes.bool.isRequired,
    isLoadingPublishers: PropTypes.bool.isRequired,
    publishersCount: PropTypes.number,
    user: PropTypes.object,
    isSnapSell: PropTypes.bool,
  };

  static defaultProps = {
    publishersCount: 0,
    isSnapSell: false,
  }

  componentDidMount(){
    const currentUrl = window.location.href
    if (!currentUrl.includes('edit') && !this.props.isSnapSell){
      window.onpopstate  = (e) => {
        window.history.replaceState({}, '', currentUrl)
        window.location.replace(getPreviewUrl(this.props.event, this.props.user));
      }
    }
  }

  renderImage(imgUrl) {
    if (imgUrl) {
      return <img src={imgUrl} className="img-fluid rounded"/>;
    }
  }

  renderSubCategoryNames() {
    const subCategories = this.props.event
      .get('sub_category_names');
    return (
      <Fragment>
        <br/>
        Sub-Category: <span>{subCategories.join(', ')}</span>
      </Fragment>
    );
  }

  render() {
    const { event, isPolling, user } = this.props;
    const imgUrl = event.get('image_url');
    const location = event.getIn(['venue', 'town']) || event.getIn(['venue', 'name']) || 'Virtual Event'

    return (
      <Row className={styles.checkoutPreview}>
        {(isPolling || imgUrl) && <div className="col-4 col-sm-3 align-self-center text-center">
          {isPolling ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw"></i> : this.renderImage(imgUrl)}
        </div>}
        <div className="col">
          <div>
            <h2 className="d-inline-block mb-0">{event.get('title')}</h2>
            <h3>{moment.parseZone(event.get('start_datetime_local')).format('MMMM Do YYYY, h:mm a')}</h3>
          </div>

          <p>
            Location: <span>{location}</span>
            <br/>
            Category: <span>{event.get('category_name')}</span>
            {event.get('sub_category_names').isEmpty() ? null : this.renderSubCategoryNames()}
          </p>
        </div>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/CheckoutEventPreview.jsx